import "vite/modulepreload-polyfill";
import { createRoot } from "react-dom/client";
import { GalleryWidget } from "./Components/Gallery.jsx";

export function RenderGallery(configuration){
    const container = document.getElementById(configuration.container);
    const root = createRoot(container);

    root.render(
      (
        <GalleryWidget configuration={configuration} />
      ),
    );
}

document.addEventListener("DOMContentLoaded", function() {
    const widget_configs = document.querySelectorAll(".gallery-widget-config");

    for (let config of widget_configs) {
        RenderGallery(JSON.parse(config.innerText));
    }
});
